import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PropertyForm } from "@/components/agent/PropertyForm";

export const AddPropertyDialog = ({ open, onClose }) => {
  const navigate = useNavigate();
  const saved = (data) => {
    toast.success("Property added");
    navigate(`/lets/${data.id}/edit`);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-xl" data-testid="add-property-dialog">
        <DialogHeader>
          <DialogTitle>Add a property</DialogTitle>
          <DialogDescription>You can add a photo and fine-tune the criteria after saving.</DialogDescription>
        </DialogHeader>
        {open && <PropertyForm onSaved={saved} onCancel={onClose} />}
      </DialogContent>
    </Dialog>
  );
};
